import React, { useEffect, useState } from 'react';
import { GET, PUT, POST } from '../../../helpers/httphelper';
import ArticleImage from '../components/ArticleImage';
import Profile from '../components/Profile';
import LikeBar from '../components/LikeBar';
import ArticleProfile from '../components/ArticleProfile';
import ArticleSearch from '../components/ArticleSearch';
import ArticleSearchResult from '../components/ArticleSearchResult';
import ReadArticle from '../components/ReadArticle';

function Articles() {

  const [articles, setArticles] = useState([]);
  const [myArticles, setMyArticles] = useState([]);
  const [searchResult, setSearchResult] = useState([]);
  const [noResult, setNoResult] = useState(false);
  const [user, setUser] = useState({});
  const [change, setChange] = useState(false);
  const [keyword, setKeyword] = useState('');
  const [readTrigger, setReadTrigger] = useState(false);
  const [article, setArticle] = useState({});

  useEffect(() => {
    const handleGetArticles = async () => {
      try {
        const res = await GET('api/articles/get/all');
        console.log(res.data);
        setArticles(res.data);
      } catch (err) {
        console.log(err);
      }
    }

    handleGetArticles();
  }, [change]);

  useEffect(() => {
    const getData = async () => {
      try {
        let user = localStorage.getItem('user');
        console.log(user);
        const res = await GET(`api/user/getuser/${user}`);
        setUser(res.user);
        console.log(res.user);
      } catch (err) {
        console.log(err);
      }
    }

    const getArticles = async () => {
      try {
        if (localStorage.getItem('user')) {
          const res = await GET(`api/articles/get/user/${localStorage.getItem('user')}`);
          setMyArticles(res.data);
          console.log(res.data);
        }
      } catch (err) {
        console.log(err);
      }
    }

    getArticles();
    getData()
  }, []);

  const handleSearch = async () => {
    try {
      console.log(keyword)
      let ob = {
        keyword
      }
      const res = await POST('api/articles/search', ob);
      console.log(res.data)
      setSearchResult(res.data);
      if (res.data.length === 0) {
        setNoResult(true);
      } else {
        setNoResult(false);
      }
    } catch (err) {
      console.log(err)
    }
  }

  const handlePopup = (data) => {
    setArticle(data);
    console.log(article)
    setReadTrigger(true);
  }


  const handleRemoveLike = async (item) => {
    const ob = {
      articleId: item._id,
      userId: localStorage.getItem('user')
    }
    const res = await PUT('api/articles/likes/remove', ob);
    console.log(res)
    setChange(!change);
  }

  const handleAddLike = async (item) => {
    const ob = {
      articleId: item._id,
      userId: localStorage.getItem('user')
    }
    const res = await PUT('api/articles/likes/add', ob);
    console.log(res)
    setChange(!change);
  }

  return (

    <div className='container'>
      <p className='title is-size-3-mobile is-1 has-text-centered mt-5'>Articles</p>
      <div className="columns is-justify-content-center" style={{ marginLeft: '0px', marginRight: '0px' }}>
        <div className="column is-7">
          <div style={{ height: '100vh', overflowY: 'scroll' }}>
            {articles?.map((item, index) => (
              <div className='box  mb-5 m-1' key={index}>
                <Profile data={item.userId} handlePopup={handlePopup} item={item} />
                <ArticleImage data={item} />
                <LikeBar data={item} handleAddLike={handleAddLike} handleRemoveLike={handleRemoveLike} key={Math.random()} />
              </div>
            ))}
          </div>
        </div>
        <div className="column is-5 is-flex is-flex-direction-column">
          <div className="box">
            <ArticleProfile data={myArticles} user={user} />
          </div>
          <div className="box">
            <div className='mb-5'>
              <ArticleSearch handleSearch={handleSearch} setKeyword={setKeyword} />
            </div>
            <div>
              {(searchResult?.length > 0) ? searchResult?.map((item, index) => (
                <div className="box" key={index}>
                  <ArticleSearchResult data={item} handlePopup={handlePopup} />
                </div>
              )) : ""}

              {(noResult) ?
                <div className="box">
                  <p>No Articles Found</p>
                </div> : ""}
            </div>
          </div>
        </div>
      </div>
      <ReadArticle readTrigger={readTrigger} setReadTrigger={setReadTrigger} data={article} />
    </div>
  )
}

export default Articles;